import React, { useState, useRef, useEffect } from "react";
import { Button } from "antd";
import ReactMarkdown from "react-markdown";

const MarkdownText = ({ description, expandable, lessMargin, lineHeight = 1.5, lessListVerticalSpace }) => {
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const contentRef = useRef(null);
  const maxLines = 3;

  const normalizedText = description.replace(/\n{3,}/g, (match) => {
    const count = match.length;
    return "\n\n" + Array(count - 2).fill("&nbsp;  ").join("\n");
  });

  useEffect(() => {
    if (expandable) {
      const checkOverflow = () => {
        if (contentRef.current) {
          setIsOverflowing(
            contentRef.current.scrollHeight > contentRef.current.clientHeight
          );
        }
      };
      checkOverflow();
      window.addEventListener("resize", checkOverflow);
      return () => window.removeEventListener("resize", checkOverflow);
    }
  }, [expandable, normalizedText]);

  return (
    <div
      style={{
        textAlign: "left",
        color: "grey",
        fontSize: "1.1rem",
        fontWeight: "500",
        width: "100%",
        lineHeight: lineHeight,
      }}
    >
      <div
        ref={contentRef}
        style={
          expandable
            ? {
                display: "-webkit-box",
                WebkitLineClamp: !expanded ? maxLines : "unset",
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }
            : {}
        }
      >
        <ReactMarkdown
          components={{
            ul: ({ children }) => (
              <ul
                style={{
                  paddingLeft: lessMargin ? "1.5rem" : "2rem",
                  margin: "0.5rem 0",
                }}
              >
                {children}
              </ul>
            ),
            ol: ({ children }) => (
              <ol
                style={{
                  paddingLeft: lessMargin ? "1.5rem" : "2rem",
                  margin: "0.5rem 0",
                }}
              >
                {children}
              </ol>
            ),
            li: ({ children }) => (
              <li style={{ marginBottom: lessListVerticalSpace ? "-1.25rem" : "0.3rem" }}>{children}</li>
            ),
            p: ({ children }) => (
              <p style={{ marginBottom: "0.7rem", fontWeight: "500" }}>{children}</p>
            ),
            strong: ({ children }) => (
              <strong style={{ color: '#606060' }}>{children}</strong>
            ),
          }}
        >
          {normalizedText}
        </ReactMarkdown>
      </div>

      {expandable && isOverflowing && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            type="link"
            onClick={() => setExpanded(!expanded)}
            style={{ padding: 0, fontSize: "1rem", fontWeight: "500" }}
          >
            {expanded ? "- Read Less" : "+ Read More"}
          </Button>
        </div>
      )}
    </div>
  );
};

export default MarkdownText;
